import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Form, Button, Row, Col } from "react-bootstrap";
import Message from "../../components/Message";
import Loader from "../../components/Loader";
import FormContainer from "../../components/FormContainer";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import {
  useGetUserDetailsQuery,
  useUpdateUserMutation,
} from "../../slices/usersApiSlice";

const UserEditScreen = () => {
  const { id: userId } = useParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  const {
    data: user,
    isLoading,
    error,
    refetch,
  } = useGetUserDetailsQuery(userId);

  const [updateUser, { isLoading: loadingUpdate }] = useUpdateUserMutation();

  const navigate = useNavigate();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await updateUser({ userId, name, email, isAdmin }).unwrap();
      toast.success("user updated successfully");
      refetch();
      navigate("/admin/userlist");
    } catch (err) {
      toast.error(err?.data?.message || err.error);
    }
  };

  useEffect(() => {
    if (user) {
      setName(user.name);
      setEmail(user.email);
      setIsAdmin(user.isAdmin);
    }
  }, [user]);

  return (
    <>
      <div className="text-end">
        <Link to="/admin/userlist" className="btn btn-light my-3">
          חזור
        </Link>
      </div>
      <FormContainer>
        <h1 className="text-end">ערוך לקוח</h1>
        {loadingUpdate && <Loader />}
        {isLoading ? (
          <Loader />
        ) : error ? (
          <Message variant="danger">
            {error?.data?.message || error.error}
          </Message>
        ) : (
          <Form onSubmit={submitHandler}>
            <Form.Group className="my-2" controlId="name">
              <Col xs={12} className="text-end">
                <Form.Label>שם</Form.Label>
              </Col>
              <Form.Control
                type="name"
                placeholder="Enter name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Form.Group className="my-2" controlId="email">
              <Col xs={12} className="text-end">
                <Form.Label>מייל</Form.Label>
              </Col>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                dir="rtl"
              ></Form.Control>
            </Form.Group>

            <Form.Group className="my-2 d-flex justify-content-end" controlId="isadmin">
              <Form.Check
                type="checkbox"
                label="מנהל"
                checked={isAdmin}
                onChange={(e) => setIsAdmin(e.target.checked)}
                reverse
              ></Form.Check>
            </Form.Group>

            <Row className="my-2">
              <Col className="d-flex justify-content-end">
                <Button type="submit" variant="primary">
                  עדכן
                </Button>
              </Col>
            </Row>
          </Form>
        )}
      </FormContainer>
    </>
  );
};

export default UserEditScreen;
